import React, { Component } from 'react';

class Footer extends Component {

  render() {
    const year = new Date().getFullYear();

    return (
      <section className='footer text-sm-center'>
        &copy; { year } Ignite Sales, Inc
      </section>
    );
  }

}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js